<nb-card style="max-height:700px">
  <nb-card-body style="max-width: 750px" >

    <video width="750" height="350" controls autoplay="autoplay">
      <source src="{{environment.serverUrl}}/dam/data-partial/{{uid}}/{{version}}" type="{{type}}" >
      Your browser does not support the video tag.
    </video>

  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="primary" (click)="dismiss(true)" i18n="@@Ok">OK</button>
   </nb-card-footer>
</nb-card>
